import React, { useCallback, useMemo, useState } from 'react';
import Searcher from './Searcher';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import { GET_EVALUACIONES_PAGINATED_RECLAMOS, adaptEvaluacionesArray } from '../../../../../../data/graphQL/queries/Reclamos/getContratosPaginated';

const EvaluacionField = ({
    evaluaciones,
    disabled,
    onChange,
    idPaciente
}) => {
    const columns = [
        {
            field: 'id',
            headerName: 'Nro. Contrato',
            flex: 1
        },
        {
            field: 'programa',
            headerName: 'Programa',
            flex: 2,
            sortable: false
        },
        {
            field: 'planCuidado',
            headerName: 'Plan Cuidado',
            flex: 3,
            sortable: false
        }
    ];

    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);
    const errorMessage = useMemo(() => (!!idPaciente ? null : "El creador debe seleccionar un paciente para relacionar un contrato..."), [idPaciente]);

    const getSearchParams = useCallback((textValue) => {
        const filterPaciente = {
            idPaciente: { eq: idPaciente }
        };

        const searchParams = {
            and: [filterPaciente]
        };

        if (textValue) {
            searchParams.and.push({
                or: [
                    !!parseInt(textValue) ? { idEvaluacion: { eq: parseInt(textValue) } } : {},
                    { idPlanCuidadoNavigation: { nombre: { contains: textValue } } },
                    { idTipoModuloNavigation: { descripcion: { contains: textValue } } },
                ]
            });
        }

        return searchParams;

    }, [idPaciente]);

    const handleRowClick = (row) => {
        const hasRow = evaluaciones.includes(row.id);

        onChange('evaluaciones', hasRow
            ? [...evaluaciones.filter(p => p !== row.id)]
            : [...evaluaciones, row.id]
        );
    }

    const onSelect = (newList) => {
        onChange('evaluaciones', newList);
    }

    const onDeleteRow = (selectedRowId) => {
        onChange('evaluaciones', [...evaluaciones.filter(p => p !== selectedRowId)]);
    }

    const getEntityValue = (row) => {
        const value = !!row ? `${row.id}` : null;
        return value;
    }

    return <Searcher
        displayName='Contratos'
        titleModal='Seleccionar contratos'
        entityName='contratosByPaciente'
        entityId='idEvaluacion'
        columns={CONFIGURATED_COLUMNS}
        query={GET_EVALUACIONES_PAGINATED_RECLAMOS}
        adapter={adaptEvaluacionesArray}
        getSearchParams={getSearchParams}
        onRowClick={handleRowClick}
        getEntityValue={getEntityValue}
        multiple
        errorMessage={errorMessage}
        entityIdValues={evaluaciones}
        onSelect={onSelect}
        onDeleteRow={onDeleteRow}
        disabled={disabled}
        dataGridTitle='Contratos Seleccionados'
        dataGridButtonLabel='Agregar Contratos'
    />
}

export default EvaluacionField;